<img
  *ngIf="language"
  width="20px"
  height="20px"
  src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/languages/{{
    language
  }}-plain.svg"
/>
